/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue18 } from '../../../../Fct/generics/FctParams';
import { FaRocket } from 'react-icons/fa';
import { ROCKET_POOL_ERC20 } from '../constants';
export var GetRethValue = createPlugin({
    protocol: 'ROCKETPOOL',
    type: 'GETTER',
    method: 'getRethValue',
    supportedContracts: ROCKET_POOL_ERC20,
    getParams: function () { return ({
        input: {
            to: new FctAddress({}),
            methodParams: {
                ethAmount: new FctValue18({ isPreview: true, icon: FaRocket }),
            },
        },
        output: {
            rethAmount: new FctValue18({ isPreview: true }),
        },
    }); },
});
